// errors-handler.ts
import { ErrorHandler, Injectable,Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import {MatSnackBar} from '@angular/material';
import { Router } from '@angular/router';

@Injectable()
export class ErrorsHandler implements ErrorHandler {

  constructor(private injector: Injector,
              public snackBar: MatSnackBar){}

  handleError(error: Error | HttpErrorResponse) { 

    const router = this.injector.get(Router);
    if (error instanceof HttpErrorResponse) {
      // Server or connection error happened
      if (!navigator.onLine) {
        // Handle offline error
          console.info("offline!!")
      } else {
        // Handle Http Error (error.status === 403, 404...)
        if(error.status===0){
          this.snackBar.open('Não foi Possivel Conectar! Tente Novamente Mais tarde!',"Fechar");
        }
        router.navigate(['/error']);
      }
    } else {
     // Handle Client Error (Angular Error, ReferenceError...)     
      router.navigate(['/error']);
    }

  // Log the error anyway
  console.error('It happens: ', error);
  }
}